// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ue-z","subtitle":"ve-z","contentWrap":"we-z","imgWrap":"xe-z","heading":"ye-z","copy":"ze-z"};